/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ReorderHomepagePinsMutationRequest,
  ReorderHomepagePinsMutationResponse,
  ReorderHomepagePins400,
} from '../types/ReorderHomepagePins'

function getReorderHomepagePinsUrl() {
  const res = { method: 'POST', url: `/api/v1/homepage/pins/reorder/` as const }
  return res
}

/**
 * @summary Reorder the current user's pins
 * {@link /api/v1/homepage/pins/reorder/}
 */
export async function reorderHomepagePins(
  data: ReorderHomepagePinsMutationRequest,
  config: Partial<RequestConfig<ReorderHomepagePinsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ReorderHomepagePinsMutationResponse,
    ResponseErrorConfig<ReorderHomepagePins400>,
    ReorderHomepagePinsMutationRequest
  >({
    method: 'POST',
    url: getReorderHomepagePinsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
